var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-modal',{attrs:{"title":_vm.title,"visible":_vm.dialogVisible,"footer":null},on:{"cancel":_vm.handleCancel}},[_c('div',{staticClass:"image-img"},[_c('img',{attrs:{"src":_vm.imageUrl,"alt":""}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }